import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {DecimalPipe} from "@angular/common";
import {MaterialModule} from '@modules/material/material.module';
import {AgmCoreModule} from '@agm/core';
import {TranslateModule} from '@ngx-translate/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SharedModule} from '@modules/shared/shared.module';
import { UserSettingsRoutingModule } from './user-settings-routing.module';
import {UserSettingsComponent} from './user-settings.component';
import {CompanyInformationComponent} from './company-information/company-information.component';
import {AccountSettingsComponent} from './account-settings/account-settings.component';
import {PaymentSettingsComponent} from './payment-settings/payment-settings.component';
import {AddCardComponent} from './add-card/add-card.component';
import {PrinterSettingsComponent} from '@modules/user-settings/printer-settings/printer-settings.component';
import {MiscSettingsComponent} from '@modules/user-settings/misc-settings/misc-settings.component';
import {ConsignmentSettingsComponent} from '@modules/user-settings/consignment-settings/consignment-settings.component';

@NgModule({
  imports: [
    // angular
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // libraries
    MaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDL4eB6J10hcVcClWa-UrjvvqBAbMNIujo',
      libraries: ['places']
    }),
    TranslateModule.forChild(),
    FontAwesomeModule,
    // custom
    SharedModule,
    UserSettingsRoutingModule
  ],
  declarations: [
    // components
    UserSettingsComponent,
    AccountSettingsComponent,
    PaymentSettingsComponent,
    CompanyInformationComponent,
    AddCardComponent,
    PrinterSettingsComponent,
    MiscSettingsComponent,
    ConsignmentSettingsComponent
  ],
  providers: [DecimalPipe],
  entryComponents: [AddCardComponent],
  exports: [
    UserSettingsComponent,
  ]
})

export class UserSettingsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/user-settings.module.ts